import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { PackageLayerList } from '../components/manage_packages/PackageLayerList'

export const PackageListPage = () => {
  return (
    <MasterLayout>
        <PackageLayerList />
    </MasterLayout>
  )
}
